import { getRole } from 'api/tokenStorage';

export type ProfileType = 'tutor' | 'student';

const VALID_PROFILE_TYPES = new Set<ProfileType>(['tutor', 'student']);

export const isProfileType = (value: string | undefined): value is ProfileType =>
  Boolean(value && VALID_PROFILE_TYPES.has(value as ProfileType));

type ResolveProfileTypeOptions = {
  sessionRoles?: number[];
  pathname?: string;
};

const cookieRoleIfAllowed = (sessionRoles: number[]): ProfileType | undefined => {
  const cookieRole = getRole();
  if (!isProfileType(cookieRole)) {
    return undefined;
  }
  const roleId = cookieRole === 'tutor' ? 1 : 2;
  if (sessionRoles.length > 0 && !sessionRoles.includes(roleId)) {
    return undefined;
  }
  return cookieRole;
};

/** Active profile API segment: tutor | student. Cookie only if allowed by session; route hints need matching role. */
export const resolveProfileType = ({
  sessionRoles = [],
  pathname,
}: ResolveProfileTypeOptions = {}): ProfileType | undefined => {
  const fromCookie = cookieRoleIfAllowed(sessionRoles);
  if (fromCookie) {
    return fromCookie;
  }

  if (pathname?.startsWith('/teacher') && sessionRoles.includes(1)) {
    return 'tutor';
  }
  if (pathname?.startsWith('/profile') && sessionRoles.includes(2)) {
    return 'student';
  }

  if (sessionRoles.includes(1)) {
    return 'tutor';
  }
  if (sessionRoles.includes(2)) {
    return 'student';
  }

  return undefined;
};
